import React from "react";
import { Theme } from "@pga/pga-component-library";
import Paragraph from "./common/Paragraph";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const JobInfoSectionContainer = styled.div`
  margin: 0px;
  padding: 20px 0px 10px 0px;
  border-bottom: 1px solid ${Theme.colors.bgGrey};

  h2 {
    color: ${Theme.colors.primary};
    font-family: ${Theme.fonts.PlayfairDisplay};
    font-size: 30px;
    font-weight: 600;
    letter-spacing: -0.23px;
    line-height: 40px;
  }

  h3 {
    color: ${Theme.colors.primary};
    font-family: ${Theme.fonts.PlayfairDisplay};
    font-size: 24px;
    font-weight: 600;
    letter-spacing: -0.23px;
    line-height: 40px;
  }
  h4 {
    color: ${Theme.colors.primary};
    font-family: ${Theme.fonts.Montserrat};
    font-size: 18px;
    font-weight: 500;
    letter-spacing: -0.23px;
    line-height: 40px;
  }
`;

const formatMarkdownText = (text) => {
  return (
    text
      // add new lines before headings
      .replace(/(\s#)/g, "\n$1")
      // replace <br> with new line
      .replace(/<br>/g, "\n")
      // add new lines before list items
      .replace(/\s-/g, "\n-")
  );
};

export default ({ title, children, sidebar }) => {
  return (
    <JobInfoSectionContainer>
      {sidebar ? <h4>{title}</h4> : <h3>{title}</h3>}
      <Paragraph>
        {typeof children === "string" ? (
          <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            remarkPlugins={[remarkGfm]}
            children={formatMarkdownText(children)}
          />
        ) : (
          children
        )}
      </Paragraph>
    </JobInfoSectionContainer>
  );
};
